(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kinfold-pack-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kinfold-variant-id]');
    if (!button) return;
    const selector = button.closest('[data-kinfold-pack-selector]');
    const scope = selector?.closest('.product-information, .product-details, .shopify-section');
    const productForm = scope?.querySelector('product-form-component');
    const input = productForm?.querySelector(`[ref="variantId"]`);
    if (input) {
      input.value = button.dataset.kinfoldVariantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else return;
    const price = scope?.querySelector('product-price [ref="priceContainer"] .price');
    if (price) price.textContent = button.dataset.kinfoldPrice;
    const stickySelect = document.querySelector('[data-kinfold-sticky-variant]');
    if (stickySelect instanceof HTMLSelectElement) {
      stickySelect.value = button.dataset.kinfoldVariantId;
      stickySelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', button.dataset.kinfoldVariantId);
    window.history.replaceState({}, '', url);
    selector.querySelectorAll('[data-kinfold-variant-id]').forEach((option) => {
      const isSelected = option === button;
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-pressed', String(isSelected));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
